import { GlobalPersonDrawerRole } from 'app/components/Drawers/GlobalPerson/styled';
import { PEOPLE_CONTEXT } from 'store/reducers/people/people-reducer';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

import { PeopleDrawerRoleWrapper } from './PeopleDrawerRole/styled';

export const CollectiveDirectoryPersonDrawerWrapper = styled.div`
  height: 100%;

  display: flex;
  flex-direction: column;
  padding: 38px;

  overflow-y: auto;

  background: ${({ theme }) =>
      theme.context === PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY && !theme.is_alumni
        ? `
    linear-gradient(180deg, rgba(255, 255, 255, 0.11) 0%, rgba(255, 194, 41, 0.11) 100%), #FFF;
  `
        : !theme.is_alumni
        ? `
        
  linear-gradient(180deg, rgba(255, 255, 255, 0.11) 0%, rgba(190, 188, 245, 0.11) 100%), #FFF;
  `
        : `
  linear-gradient(180deg, rgba(255, 255, 255, 0.11) 0%, rgba(135, 135, 135, 0.20) 100%), #FFF;
  `}
    ${({ theme }) =>
      theme.context === PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY
        ? `
        [data-context=${PEOPLE_CONTEXT.TEAMING}] {
          display: none;
        }
      `
        : `
      [data-context=${PEOPLE_CONTEXT.COLLECTIVE_DIRECTORY}] {
        display: none;
      }
    `}
    ${BREAKPOINTS.mobile} {
    padding: 40px 16px 242px 16px;
  }

  ${({ theme }) =>
    theme.is_alumni
      ? `
    [data-id="people-drawer-select"] {
      display: none;
    }

    [data-id="work-experience"] {
      display: none;
    }

    [data-id="common-ground"] {
      display: none;
    }
  `
      : ``}

  ${PeopleDrawerRoleWrapper} {
    margin-bottom: 20px;
  }
`;

//TOP
export const CollectiveDirectoryPersonDrawerTopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const CollectiveDirectoryPersonDrawerTopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${BREAKPOINTS.tablet} {
    align-items: center;
  }
`;

export const CollectiveDirectoryPersonDrawerSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CollectiveDirectoryPersonDrawerSelectLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const CollectiveDirectoryPersonDrawerSelectLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: var(--color-text);
`;

export const CollectiveDirectoryPersonDrawerSelectLabelIcon = styled.div`
  width: 15px;
  height: 15px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  ${({ theme }) =>
    theme.cross_kyu_teaming ? `border: 1px solid var(--color-data-industry-background-hover);` : ``}
`;

export const CollectiveDirectoryPersonDrawerCrossKyuTeamingIconBackground = styled.div<{
  isEligible: boolean;
}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: ${({ isEligible }) =>
    isEligible ? '1px solid var(--color-data-industry-background-hover)' : 'none'};
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CollectiveDirectoryPersonDrawerSelectButton = styled.button`
  max-height: 48px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 8px;
  width: 180px;

  border-radius: 100px;

  ${({ theme }) =>
    theme.isPersonSelected
      ? `
    background: var(--color-data-people-background);
    border: 2px solid transparent;
  `
      : `
    background: transparent;
    border: 2px solid var(--color-primary);
  `}

  &:disabled {
    background: var(--color-data-alumni-background-secondary);
  }

  transition: background 200ms ease;

  &:hover {
    background: var(--color-data-people-background-hover);
    border: 2px solid transparent;

    &:disabled {
      background: var(--color-data-people-background-hover);
    }
  }
`;

export const CollectiveDirectoryPersonDrawerSelectButtonText = styled.span`
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--color-text);
`;

export const CollectiveDirectoryPersonDrawerNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const CollectiveDirectoryPersonDrawerName = styled.h3`
  font-weight: 400;
  font-size: 32px;
  line-height: normal;

  color: var(--color-text);
`;

export const CollectiveDirectoryPersonDrawerPronouns = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const CollectiveDirectoryPersonDrawerRole = styled(GlobalPersonDrawerRole)`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;
`;

interface CollectiveDirectoryPersonDrawerRoleSubtextProps {
  alumni?: boolean;
}

export const CollectiveDirectoryPersonDrawerRoleSubtext = styled.span<CollectiveDirectoryPersonDrawerRoleSubtextProps>`
  ${({ alumni }) =>
    alumni
      ? `
    color: rgba(23, 28, 51, 0.50);
  `
      : `color: var(--color-text);`}
`;

export const CollectiveDirectoryPersonDrawerMeetSomeoneNewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 24px 0px;
`;

export const CollectiveDirectoryPersonDrawerMeetSomeoneNewContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;

export const CollectiveDirectoryPersonDrawerMeetSomeoneNewDescriptionWrapper = styled.div`
  max-width: 300px;
  display: flex;
  flex-direction: column;
`;

export const CollectiveDirectoryPersonDrawerMeetSomeoneNewStartQuote = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: flex-start;
  padding-bottom: 8px;
`;

export const CollectiveDirectoryPersonDrawerMeetSomeoneNewEndQuote = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: flex-end;
`;

export const CollectiveDirectoryPersonDrawerMeetSomeoneNewBio = styled.h5`
  font-weight: 400;
  font-size: 18px;
  line-height: normal;

  color: var(--color-text);
`;

export const CollectiveDirectoryPersonDrawerMeetSomeoneNewViewFullProfile = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  color: var(--color-text);
  cursor: pointer;
`;

// INFORMATION
export const CollectiveDirectoryPersonDrawerInformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;

  gap: 12px 24px;

  padding: 10px 0px;

  ${({ theme }) =>
    theme.is_alumni
      ? `
    display: none;
  `
      : ``}
`;

export const CollectiveDirectoryPersonDrawerInformationLabel = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;

export const CollectiveDirectoryPersonDrawerInformationPipe = styled.span`
  margin: 0 8px;
  color: rgba(23, 28, 51, 0.5);
`;

export const CollectiveDirectoryPersonDrawerCrossKyuTeamingLegend = styled.div<{
  isEligible: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: ${({ isEligible }) => (isEligible ? '#F6F9F4' : '#F9F4F4')};
  border-radius: 8px;
  width: 100%;
`;

export const CollectiveDirectoryPersonDrawerCrossKyuTeamingText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: var(--color-primary);
`;

export const CollectiveDirectoryPersonDrawerInformationViewProfile = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  color: rgba(23, 28, 51, 0.5);

  cursor: pointer;
`;

// SEPARATOR
export const CollectiveDirectoryPersonDrawerSeparator = styled.div`
  min-height: 1px;
  background: rgba(23, 28, 51, 0.1);
  margin: 15px 0px 15px 0px;
  width: 100%;
  transform: scale(1.1);
`;

// COLLAPSIBLE
export const CollectiveDirectoryPersonDrawerCollapsibleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const CollectiveDirectoryPersonDrawerCollapsibleTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 18px;
  margin-top: 10px;
`;

export const CollectiveDirectoryPersonDrawerCollapsibleTitleIcon = styled.div`
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  background: var(--color-data-community-background);
`;

export const CollectiveDirectoryPersonDrawerCollapsibleTitleIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 36px;
  height: 36px;

  background: var(--color-data-client-background);
  border-radius: 100%;
`;

export const CollectiveDirectoryPersonDrawerCollapsibleTitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: var(--color-text);
`;

// Actions Section

export const CollectiveDirectoryPersonDrawerActionsSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`;

export const CollectiveDirectoryPersonDrawerActionsSectionTitle = styled.h5`
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: rgba(23, 28, 51, 0.5);
  margin-bottom: 8px;
`;

export const CollectiveDirectoryPersonDrawerActionsSectionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CollectiveDirectoryPersonDrawerActionsSectionRowInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-right: 8px;
`;

export const CollectiveDirectoryPersonDrawerActionsSectionRowInfoCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  border: 2px dashed #dadada;
  height: 40px;
  width: 40px;
`;

export const CollectiveDirectoryPersonDrawerSelectButtonCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  padding: 2px;
  border: 2px solid var(--color-primary);
`;

export const CollectiveDirectoryPersonDrawerActionsSectionRowInfoIconContainer = styled.div`
  display: flex;
`;

export const CollectiveDirectoryPersonDrawerActionsSectionRowInfoText = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  color: var(--color-text);
`;

export const CollectiveDirectoryPersonDrawerActionsSectionRowCTAContainer = styled.div``;
